import React from 'react';
import FieldSelect from '../../FieldSelect/FieldSelect';
import css from './FulfillmentOptionsDropdown.module.scss';
import { required } from '../../../util/validators';

const FulfillmentOptionsDropdown = props => {
  const { publicData, formId, intl, initialValues } = props;

  const fulfillmentOptions = publicData?.fulfillmentOptions || [];
  const selectedFulfillmentOption = initialValues?.fulfillmentOptions || '';

  // console.log('Available fulfillmentOptions:', fulfillmentOptions);
  // console.log('Selected fulfillmentOption:', selectedFulfillmentOption);

  // Don't render if no fulfillment options are available
  if (!fulfillmentOptions || fulfillmentOptions.length === 0) {
    return null;
  }

  return (
    <FieldSelect
      id={`${formId}.fulfillmentOptions`}
      className={css.fulfillmentOptionsDropdownField}
      name="fulfillmentOption"
      label={intl.formatMessage({
        id: 'FulfillmentOptionsDropdown.fulfillmentOptions.label',
        defaultMessage: 'Fulfillment Options',
      })}
      validate={required(
        intl.formatMessage({
          id: 'FulfillmentOptionsDropdown.fulfillmentOptions.required',
          defaultMessage: 'Please select a fulfillment option',
        })
      )}
      value={selectedFulfillmentOption}
    >
      <option disabled value="">
        {intl.formatMessage({
          id: 'FulfillmentOptionsDropdown.fulfillmentOptions.placeholder',
          defaultMessage: 'Select fulfillment method',
        })}
      </option>

      {fulfillmentOptions.includes('delivery') && (
        <option value="delivery">
          {intl.formatMessage({
            id: 'FulfillmentOptionsDropdown.fulfillmentOptions.delivery.option',
            defaultMessage: 'Delivery (Free)',
          })}
        </option>
      )}

      {fulfillmentOptions.includes('pickup') && (
        <option value="pickup">
          {intl.formatMessage({
            id: 'FulfillmentOptionsDropdown.fulfillmentOptions.pickup.option',
            defaultMessage: 'Pickup',
          })}
        </option>
      )}

      {fulfillmentOptions.includes('delivery_fee') && (
        <option value="delivery_fee">
          {intl.formatMessage({
            id: 'FulfillmentOptionsDropdown.fulfillmentOptions.deliveryFee.option',
            defaultMessage: 'Delivery (Fee)',
          })}
        </option>
      )}

      {fulfillmentOptions.includes('onsite_only') && (
        <option value="onsite_only">
          {intl.formatMessage({
            id: 'FulfillmentOptionsDropdown.fulfillmentOptions.onsiteOnly.option',
            defaultMessage: 'On-site Use Only',
          })}
        </option>
      )}
    </FieldSelect>
  );
};

export default FulfillmentOptionsDropdown;
